import { InviteUserModalComponent } from "core-app/features/invite-user-modal/invite-user.component";
import { ConfigurationResource } from "core-app/features/hal/resources/configuration-resource";

export function apply() {
  let oldOnInit = InviteUserModalComponent.prototype.ngOnInit;
  InviteUserModalComponent.prototype.ngOnInit = function () {
    oldOnInit.apply(this);

    this.apiV3Service.configuration.get().subscribe((cfg:ConfigurationResource) => {
      this.role = cfg.invitedUserDefaultRole;
    });
  }
}
